import { useTranslation } from 'react-i18next';

import type { RealtimeConnectionState } from '@ngsos/portal-core/portal';

import { toTime } from '@/lib/time';

import { WarningBanner } from '../banners/WarningBanner';

export type RealtimeConnectionStatusBannerProps = {
  connection: RealtimeConnectionState;
};

export function RealtimeConnectionStatusBanner({ connection }: RealtimeConnectionStatusBannerProps) {
  const { t, i18n } = useTranslation();

  if (connection.status === 'connected') {
    return null;
  }

  if (connection.status === 'connecting') {
    return <WarningBanner>{t('HubConnectionStatus_Connecting')}</WarningBanner>;
  }

  return (
    <WarningBanner>
      {t('HubConnectionStatus_DisconnectedAt')} {toTime(connection.disconnectedSince, i18n.language || 'en')},{' '}
      {t('HubConnectionStatus_Reconnecting')}
    </WarningBanner>
  );
}
